var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showShare)?_c('div',{staticClass:"share-box",on:{"click":function($event){return _vm.shareHandle()}}},[_c('img',{attrs:{"src":"https://coolcdn.igetcool.com/p/2023/9/4e65e5fe7b0c7e19d547ed574a146766.png?_80x80.png","alt":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }